import { render, staticRenderFns } from "./TempNavHeader.vue?vue&type=template&id=3c356e82&scoped=true&"
import script from "./TempNavHeader.vue?vue&type=script&lang=ts&"
export * from "./TempNavHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TempNavHeader.vue?vue&type=style&index=0&id=3c356e82&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c356e82",
  null
  
)

export default component.exports